import {
	FormControl,
	FormGroup,
	FormControlLabel,
	FormLabel,
	Box,
	Grid,
	Radio,
	Checkbox,
	RadioGroup,
	TextField,
	Chip,
	Typography,
	CircularProgress,
	InputAdornment,
	Autocomplete
} from '@mui/material';
import React, { cloneElement } from 'react';
import { TextInput } from '../textInput/TextInput';
import { SelectInput } from '../selectInput/SelectInput';
import { FileInput } from '../fileInput/FileInput';
import { DateInput } from '../dateInput/DateInput';
import { CheckboxGroupInput } from '../checkboxInput/CheckboxGroupInput';
import moment from 'moment';
import { CustomButton } from '../customButton/CustomButton';
import { ButtonOptionGroup } from '../buttonOptionGroup/ButtonOptionGroup';
import { SwitchInput } from '../switchInput/SwitchInput';
import PropTypes from 'prop-types';
import SearchIcon from "@mui/icons-material/Search";
import { AutocompleteInput } from '../autocompleteInput/AutocompleteInput';
import InfoRow from '../../Pages/MisVisitasCreation/components/components/InfoRow/InfoRow';
import { TimeInput } from '../timeInput/TimeInput';

export const RenderInputByTypeMobile = ({
	input,
	handleChange,
	row,
	value,
	grided,
	marginedBottom,
	handleDelete,
	onClickImagen
}) => {
	const inputType = input.type;
	const decimalsRegex = /([-]?[0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
	const phoneRegex = /^\+[0-9]{0,14}$/;
	const basicInputProps = {
		label: input.displayName,
		variant: input.variant || 'outlined',
		name: input.name,
		required: input.required,
		onChange: e => handleChange(input.name, e.target.value),
		disabled: input.disabled,
		onBlur: input.onBlur,
		longLabel: input.longLabel,
	}

	function ItemR(props) {
		const { sx, ...other } = props;
		return (
			<Box
				sx={{
					bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
					color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'black'),
					borderRadius: 0,
					fontSize: '0.75rem',
					...sx,
					padding: 1
				}}
				{...other}
			/>
		);
	}

	ItemR.propTypes = {
		sx: PropTypes.oneOfType([
			PropTypes.arrayOf(
				PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
			),
			PropTypes.func,
			PropTypes.object,
		]),
	};

	const RenderInput = () => {
		switch (inputType) {
			case 'currency':
				const currencyValue = value ?? '';
				return <TextInput
					{...basicInputProps}
					shrink='true'
					type='text'
					value={currencyValue.toString().match(decimalsRegex)[0]}
					onChange={e => {
						let inputValue = e.target.value.replace(/\./g, '');
						const value = inputValue.match(decimalsRegex)[0];

						const floatValue = parseFloat(value.replace(',', '.'));

						if ((input.max == null || !(floatValue > input.max)) && (input.min == null || !(floatValue < input.min)))
							handleChange(e.target.name, value);
					}}
					currency={true}
					currencyAllowNegative={input.currencyAllowNegative}
				/>;
			case 'int':
				return <TextInput
					{...basicInputProps}
					shrink={input.shrink}
					type='number'
					value={value}
					onChange={e => {
						const value = parseInt(e.target.value);
						if ((input.max == null || !(value > input.max)) && (input.min == null || !(value < input.min)))
							handleChange(e.target.name, value)
					}}
					inputProps={{
						inputMode: 'numeric',
						whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip', lineHeight: 1.2,
						min: input.min,
						max: input.max,
					}}
					slotProps={input.slotProps}
				/>;
			case 'float':
				const floatValue = value ?? '';
				return <TextInput
					{...basicInputProps}
					type='number'
					value={floatValue.toString().match(decimalsRegex)[0]}
					onChange={e => {
						let inputValue = e.target.value;
						inputValue = inputValue.replace(',', '.');
						const value = parseFloat(inputValue.match(decimalsRegex)[0]);
						if ((input.max == null || !(value > input.max)) && (input.min == null || !(value < input.min)))
							handleChange(e.target.name, value);
					}}
					inputProps={{
						min: input.min,
						max: input.max,
					}}
				/>;
			case 'tel':
				return <TextInput
					{...basicInputProps}
					value={value || ''}
					onChange={e => {
						const inputValue = e.target.value;
						if (inputValue === '' || phoneRegex.test(inputValue)) {
							handleChange(e.target.name, inputValue);
						}
					}}
					inputProps={{
						maxLength: 15,
						inputMode: 'tel',
					}}
				/>;
			case 'string':
				return <TextInput
					{...basicInputProps}
					value={value}
					maxLength={input.maxLength}
					shrink={'true'}
				/>;
			case 'password':
				return <TextInput
					{...basicInputProps}
					type={'password'}
					value={value}
					maxLength={input.maxLength}
					shrink={'true'}
				/>;
			case 'long_string':
				return <TextInput
					{...basicInputProps}
					value={value || ''}
					multiline
					rows={input.longStringRows || 3}
					maxLength={input.maxLength || 2000}
				/>;
			case 'extended_string':
				return <TextInput
					{...basicInputProps}
					value={value || ''}
					multiline
					rows={16}
					maxLength={input.maxLength || 4000}
				/>;
			case 'boolean':
				return <FormControl
					key={input.name}
					disabled={input.disabled}
					sx={input.flexDirectionRow && { ...boolFlexDirRowSX }}
				>
					{input?.lightTitle && <label>{input?.displayName}{input?.required ? '*' : ''}</label>}
					{!input?.lightTitle && <h4 className='input-title'>{input?.displayName}{input?.required ? '*' : ''}</h4>}
					<RadioGroup
						row
						key={input.name + value}
						{...basicInputProps}
						onChange={e => handleChange(e.target.name, JSON.parse(e.target.value))}
						value={value}
					>
						<FormControlLabel value={true} control={<Radio size='small' />} label={input.opcionSiTexto || 'SI'} />
						<FormControlLabel value={false} control={<Radio size='small' />} label={input.opcionNoTexto || 'NO'} />
					</RadioGroup>
				</FormControl>
			case 'multiple_boolean':
				return <>
					<FormControl>
						{input.displayName && input.lightTitle && <label>{input.displayName}{input.required ? '*' : ''}</label>}
						{input.displayName && !input.lightTitle && <h4 className='input-title'>{input.displayName}{input.required ? '*' : ''}</h4>}
						<RadioGroup
							key={`rg-${input.name}`}
							row={row}
							{...basicInputProps}
							onChange={e => {
								let parsedValue;
								try {
									parsedValue = JSON.parse(e.target.value);
									handleChange(e.target.name, parsedValue)
								} catch (error) {
									parsedValue = e.target.value;
									handleChange(e.target.name, isNaN(parseInt(parsedValue)) ? parsedValue : parseInt(parsedValue))
								}
							}}
							value={value === true ? 'true'
								: value === false ? 'false'
									: value}
						>
							{input.options?.map((option, index) => (
								<FormControlLabel
									key={`${input.name}-option${index}`}
									value={option.value?.toString()}
									control={<Radio size='small' />}
									label={option.label}
									disabled={option.disabled ?? input.disabled ?? false}
								/>
							))}
						</RadioGroup>
					</FormControl>
				</>;
			case 'autocomplete':
				return <AutocompleteInput
					label={input.displayName}
					name={input.name}
					options={input.options || []}
					disabled={input.disabled}
					error={input.error}
					onOptionCreation={input.onOptionCreation}
					onChange={(id, name) => handleChange(name, id)}
					value={input.options?.find(option => option.id === value) || null}
					key={input.name}
				/>;
			case 'select':
				return <SelectInput
					{...basicInputProps}
					endAdornment={input.endAdornment}
					options={input.options || []}
					value={value}
					margin='none'
				/>;
			case 'multiple_select':
				return <SelectInput
					{...basicInputProps}
					margin='none'
					options={input.options || []}
					multiple
					value={value}
					checkMarks
					chipValue
				/>;
			case 'search':
				return <>
					<TextInput
						{...basicInputProps}
						placeholder='Buscar'
						value={value}
						searchIcon
						onClearButtonClick={input.onClearButtonClick}
						onClick={input.onClick}
					/>
				</>;
			case 'file':
				return <FileInput
					{...basicInputProps}
					loadedFileName={value?.titulo ?? ''}
					validExtensions={input.validExtensions}
					maxFileSize={input.maxFileSize}
					multiple={input.multiple}
					combineAsPdf={input.combineAsPdf}
					maxFiles={input.maxFiles ?? 10}
					loadedFileData={value}
					onChange={rawFile => handleChange(basicInputProps.name, rawFile)}
					onDeleteImage={handleDelete ? () => handleDelete(input.name) : undefined}
					onClickImagen={onClickImagen ? () => onClickImagen(input.name) : undefined}
					mobileLayout={!input.isDesktop}
					disabled={input.disabled}
					disabledLabel={input.disabledLabel}
				/>
			case 'date':
			case 'datetime':
				return <DateInput
					{...basicInputProps}
					allowedDates={input.allowedDates}
					blockedDates={input.blockedDates}
					disableFuture={input.disableFuture}
					disablePast={input.disablePast}
					value={value}
					type={inputType}
					views={inputType === 'datetime' ? ['year', 'month', 'day', 'hours', 'minutes'] : null}
					onChange={value => handleChange(input.name, moment(value).format(`yyyy-MM-DD${inputType === 'datetime' ? ' HH:mm:ss' : ''}`))}
					minDate={input.minDate}
					maxDate={input.maxDate}
				/>;
			case 'month':
			case 'year':
				return <DateInput
					{...basicInputProps}
					allowedDates={input.allowedDates}
					blockedDates={input.blockedDates}
					disableFuture={input.disableFuture}
					disablePast={input.disablePast}
					value={value}
					views={[inputType]}
					onChange={value => handleChange(input.name, moment(value).format(`${inputType === 'year' ? 'YYYY' : 'MM'}`))}
					minDate={input.minDate}
					maxDate={input.maxDate}
				/>;
			case 'time':
				return <TimeInput
					{...basicInputProps}
					value={value}
					onChange={value => handleChange(input.name, moment(value).format('HH:mm'))}
				/>;
			case 'check':
				return <FormGroup>
					<FormControlLabel
						{...basicInputProps}
						disableTypography={input.disableTypography}
						sx={input.sx}
						key={input.name + value}
						onChange={(e) => handleChange(e.target.name, e.target.checked)}
						labelPlacement={input.labelPlacement}
						control={<Checkbox checked={value} />}
					/>
				</FormGroup>
			case 'checkbox':
				return <CheckboxGroupInput
					{...basicInputProps}
					onChange={(n, v) => handleChange(n, v)}
					value={value ?? []}
					options={input.options}
					selectAllOption={input.selectAllOption}
					input={input}
				/>;
			case 'button':
				const { displayName, ...inputButton } = input;
				return <CustomButton
					{...inputButton}
					fullWidth
				>
					{input.displayName}
				</CustomButton>
			case 'button_options':
				return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
					<FormLabel sx={{ fontSize: 12, flex: '1 1 40%' }}>{input.displayName}</FormLabel>
					<FormControl size='small' sx={{ flex: '1 0 60%' }}>
						<ButtonOptionGroup
							name={input.name}
							options={input.options}
							onOptionClick={(index, e) => handleChange(e.target.name, input.options[index]?.id)}
							selectedOption={value}
							disabled={input.disabled}
							fitContent={input.fitContent}
						/>
					</FormControl>
				</Box>
			case 'item':
				return <Grid size={{ md: input.col, lg: input.col }}></Grid>
			case 'infoRow':
				return <InfoRow label={input.displayName} value={value} />
			case 'info':
				return <>
					<ItemR>
						<strong>{input.displayName}</strong>
					</ItemR>
					<ItemR>
						{value}
					</ItemR>
				</>
			case 'info_inline':
				return <>
					<ItemR sx={{ display: 'flex', flexDirection: 'row' }}>
						<strong>{input.displayName + ':'}</strong>
						<Box sx={{ marginLeft: '15px' }}> {value}</Box>
					</ItemR>
				</>
			case 'custom_switch':
				return <Box sx={{ display: 'flex', alignItems: 'center' }}>
					<span className={input.textLight ? '' : 'span-row'}>{input.displayName}</span>
					<SwitchInput
						{...basicInputProps}
						onChange={e => handleChange(e.target.name, e.target.checked)}
						checked={value}
						className='switch-row container'
					/>
				</Box>
			case 'chip_preview':
				return <>
					<h4 className='input-title' component='legend'>{input.displayName}</h4>
					{Boolean(value?.length) && value?.map((label, index) =>
						<Chip key={index} label={label} className='chip-preview' />
					)}
					{!Boolean(value?.length) && <span>Sin seleccionar...</span>}
				</>;
			case 'text':
				return <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', ...input.sxContainer }}>
					<Typography sx={input.sxText}>{input.displayName}</Typography>
				</Box>
			case 'autocomplete_complex':
				return (
					<Autocomplete
						disabled={input.disabled || false}
						options={input.options || []}
						disableClearable={input.disableClearable || false}
						noOptionsText={value ? "No hay coincidencias" : "Escriba para buscar"}
						onChange={(_, newValue) => handleChange(input.name, newValue)}
						filterOptions={input.filterOptions}
						renderOption={input.renderOption ? input.renderOption : (props, option) => (
							<Box {...props} key={option.id}>
								{option.label}
							</Box>
						)}
						renderInput={(params) => (
							<TextField
								{...params}
								sx={{
									".MuiOutlinedInput-root": { paddingRight: "15px !important" },
								}}
								label={input.displayName}
								margin="none"
								size="small"
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<InputAdornment position="end">
											{input.loading ? (
												<CircularProgress color="inherit" size={20} />
											) : (
												<SearchIcon className="search-icon" />
											)}
										</InputAdornment>
									),
								}}
							/>
						)}
						value={value}
					/>
				);
			default:
				break;
		}
	}

	if (grided) return (
		<Grid sx={marginedBottom ? { marginBottom: 2.5 } : { marginTop: 2.5 }} size={{ xs: 12 }}>
			{RenderInput()}
		</Grid>
	)
	return RenderInput();
}

const boolFlexDirRowSX = {
	display: 'flex',
	flexDirection: 'row',
	gap: 2
}